import { render, staticRenderFns } from "./SubsInput.vue?vue&type=template&id=115f6b4d&scoped=true"
import script from "./SubsInput.vue?vue&type=script&lang=js"
export * from "./SubsInput.vue?vue&type=script&lang=js"
import style0 from "./SubsInput.vue?vue&type=style&index=0&id=115f6b4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f6b4d",
  null
  
)

export default component.exports